import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import CardFunPairingNumberedList from '../Cards/CardFunPairing/CardFunPairingNumberedList';

const HomepageHeroLatelyMostRead = ({ mostRead }) => {
  return (
    <div className="mt-10 ">
      <div className="px-6 lg:px-0 sm:px-10">
        <h4 className="pb-4 lg:mb-10 mb-4 sm:mb-6 border-b stink-h4 border-smoke lg:pb-3.5 ">
          Most Read
        </h4>
      </div>

      <div className="grid grid-flow-col px-6 overflow-auto lg:flex lg:flex-col no-scrollbar gap-x-6 lg:gap-x-0 lg:px-0 sm:px-10">
        {mostRead.map((item, index) => {
          const { id, publishedDate, slug, title } = item;
          const lastCard = index === mostRead.length - 1;
          return (
            <div
              key={id}
              className={classnames(
                { 'lg:mb-10': !lastCard },
                'w-56',
                'lg:w-auto',
              )}
              data-component-id="most_read_link"
            >
              <CardFunPairingNumberedList
                date={publishedDate}
                index={index + 1}
                slug={slug}
                title={title}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

HomepageHeroLatelyMostRead.propTypes = {
  mostRead: PropTypes.array,
};

export default HomepageHeroLatelyMostRead;
